import {DownloadApp} from '@/i18n/model/en/page-content/download-app'


export const PageContent = {
  downloadApp: DownloadApp,
}
